import { useState } from "react";
import "./FAQPage.css";

const FAQS = [
  {
    question: "Who is the founder of Dwellora Designs?",
    answer:
      "Ar. Gajanan V. Shetkar is the founder of Dwellora Designs and a COA-registered architect with over 10 years of professional experience.",
  },
  {
    question: "Who is behind Dwellora Designs?",
    answer:
      "The founding team brings together expertise in architecture, product design and marketing — combining 10+ years of average professional experience across design, product development and business.",
  },
  {
    question: "Is Dwellora Designs a government-registered company?",
    answer:
      "Yes. Dwellora Designs operates under Dwellora Designs LLP, a legally registered Limited Liability Partnership with the Ministry of Corporate Affairs (ROC), Government of India. This ensures compliant, accountable and professional operations.",
  },
  {
    question: "What is Dwellora Designs?",
    answer:
      "Dwellora Designs is a design-led company providing turnkey solutions, bringing design, product expertise and execution together to deliver complete projects.",
  },
  {
    question: "How does Dwellora Designs deliver furniture and specialised products?",
    answer:
      "Dwellora Designs develops each product through its in-house design team, selects the appropriate materials and specifications, and customises the product to suit the project. We then assign it to the right specialist manufacturer and coordinate the process through production, quality checks, delivery and installation.",
  },
  {
    question: "Who designs the furniture and products?",
    answer:
      "Our in-house design team develops furniture and product designs as part of the overall project, ensuring each element is designed specifically for the space and overall design vision.",
  },
  {
    question: "Can Dwellora Designs customise products from specialist manufacturers?",
    answer:
      "Yes. Products can be customised based on the project's design, dimensions, materials, finishes and functional requirements. Dwellora Designs communicates these specifications to the specialist manufacturer and coordinates production accordingly.",
  },
  {
    question: "Does the specialist manufacturer decide the materials?",
    answer:
      "No. Material selection and product specifications are determined by Dwellora Designs based on the design, application, quality requirements and project needs. The selected specialist then manufactures the product according to those specifications.",
  },
  {
    question: "How does Dwellora Designs maintain the quality of specialist-made products?",
    answer:
      "Dwellora Designs specifies the materials, finishes, hardware and construction requirements before production. We work closely with the selected specialist to ensure the product is manufactured according to the approved design and specifications.",
  },
  {
    question: "Who provides the warranty for the products?",
    answer:
      "Dwellora Designs provides the product warranty for furniture and specialised products supplied as part of your project, subject to the applicable warranty terms. This gives you an added layer of assurance beyond the manufacturer's involvement.",
  },
  {
    question: "How does Dwellora Designs ensure the longevity of furniture?",
    answer:
      "Dwellora Designs specifies the materials, construction standards, finishes and hardware to be used by the specialist manufacturer. These specifications are selected to improve the strength, durability and life of the product and help minimise potential issues over time.",
  },
  {
    question: "Does Dwellora Designs manufacture its own furniture?",
    answer:
      "No. We believe specialised products are best made by specialists. Dwellora Designs focuses on design, material selection, specifications, customisation, quality and coordination, while selected specialists handle manufacturing.",
  },
  {
    question: "Why doesn't Dwellora Designs have its own factory?",
    answer:
      "We believe no single factory can be the best at every type of product. Instead, we work with specialists who focus on their specific craft, while Dwellora Designs controls the design, specifications and overall delivery.",
  },
  {
    question: "Is everything made in a factory?",
    answer:
      "No. Every project is different. Dwellora Designs combines on-site craftsmanship with specialist-made products, choosing the right approach for each part of the project.",
  },
  {
    question: "Will I have to deal with multiple manufacturers and contractors?",
    answer:
      "No. Dwellora Designs acts as your single point of contact and coordinates the required specialists, manufacturers and on-site teams throughout the project.",
  },
  {
    question: "Can my furniture and products be customised?",
    answer:
      "Yes. Products can be customised around your space, dimensions, requirements, materials, finishes and overall design vision rather than being limited to standard catalogue options.",
  },
  {
    question: "Who coordinates the project until installation?",
    answer:
      "Dwellora Designs coordinates the complete process from design and material selection to specialist manufacturing, on-site execution, delivery and installation, giving you one point of contact throughout the project.",
  },
  {
    question: "What kind of work does Dwellora Designs handle on site?",
    answer:
      "Depending on the project, Dwellora Designs coordinates and delivers work such as carpentry, civil work, electrical, painting, lighting, false ceiling, installation and other site-specific requirements.",
  },
  {
    question: "How do I start a project with Dwellora Designs?",
    answer:
      "Share your requirements and vision with us. Our team will understand your project, discuss the possibilities and guide you through the next steps.",
  },
];

export default function FAQPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  return (
    <div className="faq-page">
      <div className="faq-page-wrap">
        <div className="faq-page-header">
          <h1 className="faq-page-title">Frequently Asked Questions</h1>
          <p className="faq-page-subtitle">
            Everything you need to know about Dwellora Designs, our process,
            and how we work.
          </p>
        </div>

        <div className="faq-page-list">
          {FAQS.map((faq, index) => (
            <div
              className={`faq-page-item ${openIndex === index ? "is-open" : ""}`}
              key={faq.question}
            >
              <button
                type="button"
                className="faq-page-question"
                onClick={() => toggleFaq(index)}
                aria-expanded={openIndex === index}
              >
                <span>{faq.question}</span>
                <span className="faq-page-icon" aria-hidden="true">
                  {openIndex === index ? "−" : "+"}
                </span>
              </button>
              {openIndex === index && (
                <p className="faq-page-answer">{faq.answer}</p>
              )}
            </div>
          ))}
        </div>

        <div className="faq-contact-card">
          <h2 className="faq-contact-title">Still Have Questions?</h2>
          <p className="faq-contact-desc">
            Speak directly with our design team and get clarity before you
            begin your project.
          </p>
          <a href="tel:++919158914222" className="faq-contact-button">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true">
              <path d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1-.2 1.1.4 2.3.6 3.5.6.6 0 1.1.5 1.1 1.1V20c0 .6-.5 1.1-1.1 1.1C10.9 21.1 2.9 13.1 2.9 4.1 2.9 3.5 3.4 3 4 3h3.3c.6 0 1.1.5 1.1 1.1 0 1.2.2 2.4.6 3.5.1.3 0 .7-.2 1L6.6 10.8Z" />
            </svg>
            <span>+91 91589 14222</span>
          </a>
        </div>
      </div>
    </div>
  );
}